import { Link, useRouteError } from "react-router-dom";

import { Button } from "@/components/ui/button";
import LogoIcon from "@/assets/logo.png";
import { routes } from "@/routes/constants";

interface RouteError {
  message?: string;
  statusText?: string;
  stack?: string;
}

export default function ErrorPage() {
  const error = useRouteError() as RouteError;
  const errorMessage = error?.message || error?.statusText || "Une erreur inattendue s'est produite";

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-screen bg-white">
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <div className="flex flex-col items-center text-center">
            <div className="mb-6">
              <img src={LogoIcon} alt="Macaron logo" className="w-20 h-auto" />
            </div>

            <h1 className="text-2xl font-bold text-gray-900 mb-2">Erreur</h1>

            <div className="w-full mt-4 p-4 bg-red-50 border border-red-200 rounded-md">
              <p className="text-sm font-semibold text-red-800 mb-2">Détails de l'erreur</p>
              <p className="text-sm text-red-700 text-left break-words">{errorMessage}</p>
            </div>

            <div className="mt-6 flex gap-3 w-full flex-col">
              <Link to={routes.root.path} className="w-full">
                <Button className="w-full" variant="default">
                  Retour à l'accueil
                </Button>
              </Link>
              <Button onClick={handleReload} variant="outline" className="w-full">
                Recharger la page
              </Button>
            </div>

            <p className="text-sm leading-6 text-gray-600 mt-4">
              Si cette erreur persiste, veuillez contacter le support.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
